(function () {
  var data = window.SVEMOB_CATALOG || {};
  function query(brand, model, type) {
    function quoted(value) { return '"' + value.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"'; }
    var parts = ['tag:' + quoted(brand)];
    if (model) parts.push('tag:' + quoted(model));
    if (type) parts.push('product_type:' + quoted(type));
    return parts.join(' AND ');
  }
  window.svemobCatalogQuery = query;
  function init(scope) {
    scope.querySelectorAll('[data-catalog]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      var details = root.querySelector('[data-catalog-details]');
      var accessories = root.querySelector('[data-accessory-details]');
      var brands = root.querySelector('[data-catalog-brands]');
      var models = root.querySelector('[data-catalog-models]');
      var parts = root.querySelector('[data-catalog-parts]');
      var filter = root.querySelector('[data-catalog-model-search]');
      var chosen = root.querySelector('[data-catalog-selected]');
      var brand = 'Apple', selected = null;
      function link(label, q) {
        var a = document.createElement('a');
        var url = new URL(root.dataset.searchUrl, location.origin);
        url.searchParams.set('type', 'product'); url.searchParams.set('q', q);
        url.searchParams.set('options[prefix]', 'none');
        var preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        a.href = url.pathname + url.search; a.textContent = label;
        return a;
      }
      function button(label, active, action) {
        var b = document.createElement('button'); b.type = 'button'; b.textContent = label;
        b.setAttribute('aria-pressed', String(active)); b.addEventListener('click', action); return b;
      }
      function renderParts() {
        parts.replaceChildren();
        chosen.textContent = selected ? brand + ' › ' + selected.name : 'Välj en modell';
        if (!selected) return;
        if (!Object.keys(selected.types).length) {
          var empty = document.createElement('p'); empty.textContent = 'Det finns inga produkter för den här modellen i sortimentet just nu.'; parts.append(empty); return;
        }
        parts.append(link('Alla delar till ' + selected.name + ' →', query(brand, selected.name)));
        Object.keys(selected.types).sort(function (a,b) { return a.localeCompare(b,'sv'); }).forEach(function (type) {
          parts.append(link(type, query(brand, selected.name, type)));
        });
      }
      function renderModels() {
        var list = (data[brand] || {models:[]}).models.filter(function (model) { return model.name.toLowerCase().includes(filter.value.trim().toLowerCase()); });
        models.replaceChildren();
        list.forEach(function (model) {
          models.append(button(model.name, selected === model, function () {
            selected = model;
            models.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.textContent === model.name)); });
            renderParts();
            if (matchMedia('(max-width: 767px)').matches) chosen.scrollIntoView({block:'nearest',behavior:'smooth'});
          }));
        });
        if (!list.length) { var p = document.createElement('p'); p.textContent = 'Ingen modell matchar din sökning.'; models.append(p); }
      }
      function selectBrand(value) {
        brand = value; selected = null; filter.value = '';
        brands.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.textContent === brand)); });
        renderModels(); renderParts();
      }
      Object.keys(data).filter(function (b) { return data[b].models.length; }).forEach(function (b) {
        brands.append(button(b, b === brand, function () { selectBrand(b); }));
      });
      var accessoryLinks = root.querySelector('[data-catalog-accessories]');
      accessoryLinks.append(link('Alla Vidvie-produkter →', query('Vidvie')));
      Object.keys((data.Vidvie || {}).types || {}).forEach(function (type) { accessoryLinks.append(link(type, query('Vidvie', null, type))); });
      filter.addEventListener('input', renderModels);
      function close() { details.open = false; accessories.open = false; }
      root.querySelector('[data-catalog-close]').addEventListener('click', function () { close(); details.querySelector('summary').focus(); });
      root.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var was = details.open ? details : accessories; close(); was.querySelector('summary').focus(); } });
      document.addEventListener('click', function (e) { if (!root.contains(e.target) && !e.target.closest('[data-catalog-toggle]')) close(); });
      details.addEventListener('toggle', function () {
        if (details.open) accessories.open = false;
        document.querySelectorAll('[data-catalog-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', String(details.open)); });
      });
      accessories.addEventListener('toggle', function () { if (accessories.open) details.open = false; });
      selectBrand(brand);
    });
    scope.querySelectorAll('[data-catalog-toggle]').forEach(function (b) {
      if (b.dataset.ready) return; b.dataset.ready = 'true';
      b.addEventListener('click', function () {
        var menu = b.closest('header').querySelector('[data-catalog-details]');
        menu.open = !menu.open;
        if (menu.open) menu.querySelector('[data-catalog-model-search]').focus();
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
